import styles from "../aic.module.css";

interface AioLabelProps {
  id: string;
  label?: string;
  noColon?: boolean;
  htmlFor?: string;
}

/**
 * Label component for form elements.
 *
 * @param props - The component props for the aioLabel component
 * @param props.id - The id for the label element
 * @param props.label - The text label to display
 * @param props.noColon - If true, do not append a colon after the label
 * @param props.htmlFor - The id of the form element this label is for
 */
export const AioLabel = (props: AioLabelProps): React.ReactElement => {
  if (props.label === undefined) return <></>;

  return (
    <label
      id={props.id}
      className={styles.aioLabel}
      htmlFor={props.htmlFor}
    >{`${props.label}${!props.noColon && props.label ? ":" : ""}`}</label>
  );
};

AioLabel.displayName = "AioLabel";
